export default __webpack_public_path__ + "static/media/walletNegative.64e1fb14.svg";